module.exports = __webpack_public_path__ + "static/media/broken-ceramics.94918b43.jpg";